import { Component, OnDestroy, OnInit } from '@angular/core';
import { Alert, AlertType } from '../shared/alert.model';
import { MessageService } from '../shared/message.service';
import { firstValueFrom, forkJoin, from, Observable, of, Subscription } from 'rxjs';
import { MessageType } from '../shared/messageType';
import { SecurityService } from "../shared/security.service";
import { UserCustomerService } from '../users/services/user-customer.service';
import { CustomerSettings } from '../users/models/CustomerSettings';
import { CustomerSupportService } from '../customer-support/services/customer-support.service';
import { settings } from 'cluster';
import { ActivatedRoute } from '@angular/router';

export type MyProfileType = 'demographic' | 'reset-password'; //TODO: Security questions to come

@Component({
    selector: 'my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit, OnDestroy {

  profile: MyProfileType = 'demographic';

  // success/failure messages
  alert: Alert;
  messageSubscription: Subscription;
  isFederatedUser: boolean;
  isSupport: boolean;
  mfaEnabled: boolean;
  redirectFromOtherApp = false;
  constructor(
    private messageService: MessageService,
    private securityService: SecurityService,
    private customerSettingsService: UserCustomerService,
    private customerSupportService: CustomerSupportService,
    private route: ActivatedRoute
  ) {

    this.messageSubscription = this.messageService.get().subscribe(message => {



      window.scroll(0, 0);
      if (message) {
        if (message instanceof Alert) {
          this.alert = message;
        } else if (message.type === MessageType.UserSQSaved || message.type === MessageType.FactorResetted) {
          this.alert = { type: AlertType.SUCCESS, message: message.message };
          this.clearAlerts();

          if (this.redirectFromOtherApp && message.type === MessageType.UserSQSaved) {
            this.back();
          }

        }
      }
    });


  }

  back() {
    let redirectTo = this.route.snapshot.queryParams.afterSaveRedirect;
    if (redirectTo) {
      window.location.href = redirectTo;
    }
  }

  async ngOnInit() {

    this.redirectFromOtherApp = this.route.snapshot.queryParams.afterSaveRedirect
    this.isSupport = await firstValueFrom(this.securityService.isSupportUser());


    if (this.isSupport )
      return;

    if (!this.isSupport ) {
      let results = await firstValueFrom(forkJoin({
        settings: this.customerSettingsService.getSettings(),
        isAuthenticated: this.securityService.isAuthenticated(),
        isFederated: this.securityService.isFederatedUser()
      }));

      this.isFederatedUser = results.isFederated;
	      const isUserMfaEnabled = await firstValueFrom(this.securityService.mfaEnabled());
	      this.mfaEnabled = results.isAuthenticated && results.settings.customerEnabledMFA && isUserMfaEnabled;

    }

  }

  clearAlerts() {
    setTimeout(() => this.alert = null, 5000);
  }

  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
  }
}
